import "../../../../src/App.css";
import React, { useState, useEffect } from "react";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ExcelExport from "../../../components/ExcelExport/ExcelExportAccounts";
import filterIcon from "../../../Icons/filterIcon.png";
import companyName from '../../../images/DBB Worldwide Private Limited.png'
import companyLogo from '../../../images/DBB 94.png'
import "./BalanceSheet.css"


function BalanceSheet(){

    return (
        <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{
            padding: "4rem 1rem 1rem 1rem",
            width: "94%",
            backgroundColor: "#F4F4F4",
          }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Balance Sheet | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Accounts & Finance</span>
                  <span style={{ fontSize: "20px",paddingLeft:"10px" }}>&gt; Reports</span>
                  <span style={{ fontSize: "20px",paddingLeft:"10px" }}>&gt;  Balance Sheet</span>
                </h1>

              </div>
             
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
              <div style={{ display: "flex", justifyContent: "space-between",marginBottom:"20px" }}>
                  <button className="filterButton">
                    <img src={filterIcon} />
                    {" "}FILTER
                  </button>
                  
                  <div style={{ display: "flex",justifyContent:"flex-end" }}
                  
                  >
                     <button style={{width:"32%",marginRight:"18px",paddingRight:"10px",fontSize:"17px",color:"rgb(106, 106, 106)",height:"48px",marginRight:"10px",border:" 1px solid #c0c6cc"}}
                    className=""
                  >
                + Add
                  </button>
                    {/* <p
                    className="icon"
                    style={{
                      textAlign: "center",
                      padding: "7px",
                      fontSize: "18px",
                      fontWeight: "bold",
                      width: "11rem",
                      height: "3rem",
                      borderRadius: "0.5rem",
                      color: "#6A6A6A",
                      backgroundColor: "white",
                      marginRight: "13px",
                    }}
                  >
                      {" "}
                    </p> */}
                      <ExcelExport  />
                  </div>
                  
                </div>
            <hr/>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
              <img src={companyName} className="img-fluid"/>
              </div>
              <div>
<img src={companyLogo} className="img-fluid"/>
              </div>
            </div>
            <hr/>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
            <h6 style={{fontSize:'16px', color:'#6a6a6a',fontWeight:'700'}}>Address : <span style={{fontWeight:'400'}}>2nd Floor, Plot No. 269, Phase 4, Udyog Vihar, Sector 18, Gurugram, Haryana - 122015</span></h6>
              </div>
              <div>
              <h6 style={{fontSize:'16px', color:'#6a6a6a',fontWeight:'700'}}>Period : <span style={{fontWeight:'400'}}>01 Apr 2024 to 05 Feb 2025</span></h6>
              </div>
            </div>
            <hr/>
            <h2
                                    className="Venderheading"
                                    style={{
                                        fontSize: "22px",
                                        paddingLeft: "16px",
                                        paddingTop: "7px",
                                    }}
                                >
                                    Balance Sheet
                                </h2>
                                <div className="balance-sheet row px-0">
                                  <div className="col-6">
                                  <div className="balance-sheet-column p-0">
        <div className="py-2 px-2" style={{display:'flex',justifyContent:'space-between',alignItems:'center', backgroundColor:'#E6DDFF',marginBottom:'10px'}}>
        <h5 style={{color:'#5B489D',fontSize:'20px' ,fontWeight:'bold'}}>Liabilities</h5>
        <h5 style={{color:'#5B489D',fontSize:'20px' ,fontWeight:'bold'}}>Current Year(₹)</h5>
        </div>

        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Capital Amount</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
      <div className="balance-sheet-column p-0">
        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Current Liabilities</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
      <div className="balance-sheet-column p-0">
        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Loan Liabilities</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
      <div className="balance-sheet-column p-0">
        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Duties & Taxes</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6',border:'1px solid black'}} className="balance-item">
        <h6>Grand Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
                                  </div>
                                  <div className="col-6">

      <div className="balance-sheet-column p-0">
      <div className="py-2 px-2" style={{marginBottom:'10px',display:'flex',justifyContent:'space-between',alignItems:'center', backgroundColor:'#E6DDFF'}}>
        <h5 style={{color:'#5B489D',fontSize:'20px' ,fontWeight:'bold'}}>Assets</h5>
        <h5 style={{color:'#5B489D',fontSize:'20px' ,fontWeight:'bold'}}>Current Year(₹)</h5>
        </div>
        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Fixed Assets</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
      <div className="balance-sheet-column p-0">
        <div className="balance-item">
          <h6 style={{borderBottom:'1px solid #6a6a6a'}}>Current Assets</h6>
        </div>
        <div className="balance-item">
          <h6>-</h6>
          <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div className="balance-item">
        <h6>-</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6'}} className="balance-item">
        <h6>Total</h6>
        <h6>0.00</h6>
        </div>
        <div  style={{backgroundColor:'#DEE2E6',border:'1px solid black'}} className="balance-item">
        <h6>Grand Total</h6>
        <h6>0.00</h6>
        </div>
      </div>
                                  </div>
    

    </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    )
}

export default BalanceSheet;